import React from 'react';
import styled from 'styled-components';

const Paragraph = styled.p`
  all: initial;
  display: block;

  p {
    line-height: 24px !important;
    font-size: 15px !important;
    font-weight: 500 !important;
    color: #404040 !important;
  }
`;

const Description = ({ children }) => <Paragraph dangerouslySetInnerHTML={{ __html: children }} />;

export default Description;
